module.exports = __webpack_public_path__ + "img/start2.1ab95335.svg";